import AnnouncementBar from "./AnnouncementBar.jsx";
import FeatureBanner from "./FeatureBanner.jsx";
import InfoCards from "./InfoCards.jsx";
import SectionCarousel from "./SectionCarousel.jsx";
import SectionCollage from "./SectionCollage.jsx";
import SectionNews from "./SectionNews.jsx";
import SectionOverlap from "./SectionOverlap.jsx";
import SectionStack from "./SectionStack.jsx";
import StatsBanner from "./StatsBanner.jsx";

/**
 * Routes a section object to the correct component by layout type.
 *
 * layout values:
 *   stack | overlap | collage | carousel | split  — existing types
 *   banner | stats | news | announcement          — new AWS-style types
 */
function renderSection(s, key) {
  switch (s.layout) {
    case "infocards":    return <InfoCards       key={key} cards={s.cards} section={s} />;
    case "stack":        return <SectionStack    key={key} section={s} />;
    case "overlap":      return <SectionOverlap  key={key} section={s} />;
    case "collage":      return <SectionCollage  key={key} section={s} />;
    case "carousel":     return <SectionCarousel key={key} section={s} />;
    case "split":        return <SectionOverlap  key={key} section={s} />;
    case "banner":       return <FeatureBanner   key={key} section={s} />;
    case "stats":        return <StatsBanner     key={key} section={s} />;
    case "news":         return <SectionNews     key={key} section={s} />;
    case "announcement": return (
      <AnnouncementBar
        key={key}
        message={s.message}
        linkLabel={s.linkLabel}
        linkHref={s.linkHref}
      />
    );
    default: return null;
  }
}

export default function PageSections({ sections }) {
  if (!sections?.length) return null;

  return (
    <>
      {sections.map((s, i) => s.hidden ? null : renderSection(s, s.id ?? i))}
    </>
  );
}
